module.exports = __webpack_public_path__ + "img/rs.192092d6.svg";